export const downloadBlobFile = (blobData, filename) => {
  const blob = blobData instanceof Blob ? blobData : new Blob([blobData]);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const downloadCsvFile = (content, filename) => {
  downloadBlobFile(
    new Blob([content], { type: "text/csv;charset=utf-8;" }),
    filename,
  );
};
